import { useEffect } from 'react';
import { Image } from 'react-native';
import { IImageItem } from 'src/models/UploadImages';

export const useImagePreloader = (
  images: IImageItem[],
  currentPage: number,
  itemsPerPage: number
) => {
  useEffect(() => {
    if (images.length === 0) return;

    // Preload next page images
    const nextPageStart = (currentPage + 1) * itemsPerPage;
    const nextPageEnd = (currentPage + 2) * itemsPerPage;
    const nextPageImages = images.slice(nextPageStart, nextPageEnd);

    // Also preload previous page if exists
    const prevPageStart = Math.max(0, (currentPage - 1) * itemsPerPage);
    const prevPageEnd = currentPage * itemsPerPage;
    const prevPageImages = currentPage > 0 ? images.slice(prevPageStart, prevPageEnd) : [];

    const imagesToPreload = [...nextPageImages, ...prevPageImages];

    imagesToPreload.forEach(img => {
      if (img.imageUrl) {
        Image.prefetch(img.imageUrl).catch(() => {
          // Silently handle prefetch errors
        });
      }
    });
  }, [images, currentPage, itemsPerPage]);
};